<div class="row" *ngIf="widgetType">
  <div class="col-lg-5">
    <div class="row">
      <div class="col-lg-7">
        <div class="form-group input-group-sm">
          <label>Name</label>
          <input
            type="text"
            placeholder="name"
            class="form-control"
            [(ngModel)]="w.name"
          />
        </div>
      </div>
      <div class="col-lg-5">
        <div class="form-group input-group-sm">
          <label>Refresh (s)</label>
          <input
            min="60"
            type="text"
            placeholder="refresh interval"
            class="form-control"
            [(ngModel)]="w.refreshInterval"
          />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group input-group-sm">
          <label>Period</label>
          <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group input-group-sm">
          <label>Min Height</label>
          <input
            min="60"
            type="text"
            placeholder="min height"
            class="form-control"
            [(ngModel)]="w.minHeight"/>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group input-group-sm">
          <label>Widget Size</label>
          <select [(ngModel)]="w.size" class="input-group form-select">
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group input-group-sm mb-3">
          <label>Text Size</label>
          <select [(ngModel)]="w.textSize" class="input-group form-select">
            <option value="text-small">Small</option>
            <option value="text-medium">Medium</option>
            <option value="text-large">Large</option>
          </select>
        </div>    
        <div class="form-group input-group-sm">
            <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showChart" /> Show Chart
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showStatus" /> Show Status
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showValue" /> Show Value
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showCategories" /> Show Categories
        </div>  
      </div>
    </div>
  </div>
  <div class="col-lg-5">
    <table class="table">
      <tr>
        <th>
          <label>Zone Min</label>
        </th>
        <th>
          <label>Zone Max</label>
        </th>
        <th>Colour</th>
        <th><a (click)="addZoneColor(w)"><i class="fa fa-plus"></i></a></th>
      </tr>
      <tr *ngIf="w.zoneColours == null || w.zoneColours.length == 0">
          <td colspan="3">No Zone Colors</td>
      </tr>
      <tr *ngFor="let zoneObj of w.zoneColours">
        <td>
          <input type="number" [(ngModel)]="zoneObj.min" class="input-group form-control"/>
        </td>
        <td>
          <input type="number" [(ngModel)]="zoneObj.max" class="input-group form-control"/>
        </td>
        <td>
          <button [style.background]="zoneObj.colour" [cpPosition]="'top'" [(colorPicker)]="zoneObj.colour" [cpPresetLabel]="'Standard'" [cpPresetColors]="colours" class="colour-picker-button"></button>
        </td>
        <td>
            <a (click)="removeZoneColour(w, zoneObj)"><i class="fa fa-minus"></i></a>
        </td>
      </tr>
    </table>
  </div> 
</div>
<div class="row mb-3 mt-3">
  <div class="col-lg-3">
    <button
      (click)="addTimeSeries()"
      class="btn btn-primary btn-block"
      type="submit">
      <i class="fa fa-line-chart"></i> Add Time Series
    </button>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <tabset>
      <tab
        *ngFor="let tab of w.tableDetailList"
        [heading]="tab.uri == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
        [active]="tab.active"
        (select)="tab.active = true"
        (deselect)="tab.active = false"
        [disabled]="tab.disabled"
        [removable]="tab.removable"
        (removed)="removeTimeSeries(tab)">
        <div class="row">
          <div class="col-lg-6">
            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Select Time Series</label>
                  <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMultiSelect]="true" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Display Name</label>
                  <input type="text" size="20" [(ngModel)]="tab.displayName" class="form-control">
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Value Suffix</label>
                  <input type="text" size="5" [(ngModel)]="tab.valueSuffix" class="form-control">
                </div>
              </div>              
              <div class="col-lg-12" *ngIf="w.showCategories">
                <div class="form-group input-group-sm">
                  <label>Display Value</label>
                  <select [(ngModel)]="tab.displayValue" class="group-select m-b form-select">
                    <option value="min">Min</option>
                    <option value="max">Max</option>
                    <option value="average">Average</option>
                    <option value="count">Count</option>
                    <option value="sum">Sum</option>
                    <option value="sumPercentage">Sum Percentage</option>
                    <option value="countPercentage">Count Percentage</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <button class="btn btn-primary" (click)="duplicate(tab)">Duplicate Entry</button>
                </div>
              </div>
            </div>
            
          </div>
          <div class="col-lg-6">
            <table class="table">
              <tr>
                <th>
                  <label>Zone Min</label>
                </th>
                <th>
                  <label>Zone Max</label>
                </th>
                <th>Colour</th>
                <th><a (click)="addZoneColor(tab)"><i class="fa fa-plus"></i></a></th>
              </tr>
              <tr *ngIf="tab.zoneColours == null || tab.zoneColours.length == 0">
                  <td colspan="3">No Zone Colors</td>
              </tr>
              <tr *ngFor="let zoneObj of tab.zoneColours">
                <td>
                  <input type="number" [(ngModel)]="zoneObj.min" class="input-group form-control"/>
                </td>
                <td>
                  <input type="number" [(ngModel)]="zoneObj.max" class="input-group form-control"/>
                </td>
                <td>
                  <button [style.background]="zoneObj.colour" [cpPosition]="'top'" [cpPresetLabel]="'Standard'" [cpPresetColors]="colours" [(colorPicker)]="zoneObj.colour" class="colour-picker-button"></button>
                </td>
                <td>
                    <a (click)="removeZoneColour(tab, zoneObj)"><i class="fa fa-minus"></i></a>
                </td>
              </tr>
            </table>
          </div>
        </div>        
      </tab>
    </tabset>
  </div>
</div>
